import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { clearResources, setResourcePage } from '../../../../../redux/actions/resources'
import { getResourcecategories } from '../../../../../redux/actions/resourcecategories'
import { getResourcetypes } from '../../../../../redux/actions/resourcetypes'
import { IRootState } from '../../../../../redux/types'
import { IFilter } from '../../models/resource'

function useHandleFilters() {
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(search)
  const dispatch = useDispatch()

  const { globalFamilyId, globalBrandId, globalLineId, globalCountryId, globalRoleId, globalLanguageId, globalOrderById, globalTag } =
    useSelector((state: IRootState) => state.global)
  const { resourcetypes } = useSelector((state: IRootState) => state.resourcetype)
  const { resources = [], loading } = useSelector((state: IRootState) => state.resource)

  const [filters, setFilters] = useState<IFilter>({
    resourcetype_id: null,
    category_id: null,
    orderby_id: 0,
    family_id: null,
    brand_id: null,
    line_id: null,
    country_id: null,
    role_id: null,
    language_id: null,
    tag_id: null,
    searchText: ''
  })

  const handleChangeFilter = (resourcetype_id: null | number, category_id: null | number) => {
    setFilters({ ...filters, resourcetype_id, category_id })
    // Al cambiar un filtro, limpiamos los recursos viejos y reiniciamos la paginación.
    dispatch(clearResources())
    dispatch(setResourcePage(1))
    if (resourcetype_id != null) {
      searchParams.set('resourcetype_id', resourcetype_id.toString())
    } else {
      searchParams.delete('resourcetype_id')
    }

    if (category_id != null) {
      searchParams.set('category_id', category_id.toString())
    } else {
      searchParams.delete('category_id')
    }

    navigate(`${pathname}?${searchParams}`, { replace: true })
  }

  useEffect(() => {
    if (resourcetypes.length === 0) dispatch(getResourcetypes())
  }, [])

  useEffect(() => {
    if (globalCountryId !== null)
      dispatch(
        getResourcecategories({
          languageId: globalLanguageId,
          countriesId: [globalCountryId],
          familyId: globalFamilyId,
          brandId: globalBrandId
        })
      )
  }, [globalCountryId, globalFamilyId, globalBrandId])

  useEffect(() => {
    if (globalCountryId !== null) {
      setFilters({
        ...filters,
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        country_id: globalCountryId,
        line_id: globalLineId,
        role_id: globalRoleId,
        language_id: globalLanguageId,
        orderby_id: globalOrderById,
        tag_id: globalTag,
        resourcetype_id: search && searchParams.get('resourcetype_id') !== null ? Number(searchParams.get('resourcetype_id')) : null,
        category_id: search && searchParams.get('category_id') !== null ? Number(searchParams.get('category_id')) : null
      })
    }
  }, [globalFamilyId, globalBrandId, globalLineId, globalCountryId, globalRoleId, globalLanguageId, globalOrderById, globalTag])

  const noResults = resources.length === 0 && !loading

  return { filters, setFilters, handleChangeFilter, noResults }
}

export default useHandleFilters
